import { useQuery } from '@tanstack/react-query';
import useApi from '../utils/AxiosWrapper';
import { ResourceSection } from '../types/apiTypes';

export function useResources(customerId: string | null | undefined) {
  const { callProtectedApi } = useApi();
  return useQuery<ResourceSection[]>({
    queryKey: ['resources', customerId ?? ''],
    queryFn: async () => {
      const response = await callProtectedApi(
        `/charts/resources/${customerId ?? ''}`,
        'get',
        null,
        'Error fetching resources.'
      );
      return (response?.data?.data?.sections ?? []) as ResourceSection[];
    },
    enabled: !!customerId,
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
